import { SectionVO } from 'src/app/core/vo/section.vo';

export class MenuModel {
  public sectionArray: Array<SectionVO>;
  public activeMenu: SectionVO;
  public isExpanded: boolean;
}
